import Config from "../Config";
import { IEngagementFilter } from "../schema";

export const getTimePeriodLabel = (filter: IEngagementFilter): string => {
	const timePeriodOption = Config.FILTER_OPTIONS.find((option) => option.value === filter.value);
	if (timePeriodOption) return timePeriodOption.label;
	if (filter.startDate && filter.endDate) {
		return `${filter.startDate.toDateString()} to ${filter.endDate.toDateString()}`;
	}
	return "Custom Time Period";
};
